import { createSender } from 'shared/bi/bi-with-state-defaults';
import updateVodSettings from 'shared/redux/server/actions/vod-settings/update';

let sendBiEvent;

export default biHandlers =>
  ({ getState, dispatch }) =>
    next =>
      action => {
        const previousState = getState();
        const returnValue = next(action); // eslint-disable-line callback-return
        const { type } = action;
        const handler = biHandlers[type];

        if (!sendBiEvent) {
          sendBiEvent = createSender(getState());
        }

        if (handler) {
          handler({
            sendBiEvent,
            state: getState(),
            previousState,
            action,
            updateVodSettings: data => updateVodSettings(data)(dispatch, getState),
          });
        }

        return returnValue;
      };



// WEBPACK FOOTER //
// ./src/shared/bi/bi-middleware.js